import React, { useContext } from "react";
import "./Programs_Offered_Through_AF.css";
import Common_subHeading from "../../common_components/common_subHeading/Common_subHeading";
import Programs_Offered_card from "../../common_components/study_abroad/programs_Offered_card/Programs_Offered_card";
import { Context } from "../../../utils/context";

function Programs_Offered_Through_AF() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Programs_Offered_Through_AF">
        <div className="container">
          {/* <Common_subHeading subHeading="Programs Offered Through AFI" /> */}

          <Common_subHeading
            subHeading={
              language == 1
                ? "Programs Offered Through AFI"
                : "Programmes proposés par AFI"
            }
          />

          {/* CARD 1 */}
          <Programs_Offered_card
            reverse={false}
            title={
              language == 1
                ? "MBA – Master of Business Administration"
                : "MBA – Master en administration des affaires"
            }
            image="/assets/images/study_abroad/new-images/MBA.jpg"
            listBlocks={[
              {
                heading:
                  language == 1
                    ? "The MBA helps students develop"
                    : "Le MBA permet aux étudiants de développer",
                points:
                  language == 1
                    ? [
                        "Strategic thinking",
                        "International leadership skills",
                        "Cross-cultural communication",
                        "Case-study driven problem solving",
                        "Real exposure to global business practices",
                      ]
                    : [
                        "La pensée stratégique",
                        "Des compétences en leadership international",
                        "La communication interculturelle",
                        "La résolution de problèmes basée sur des études de cas",
                        "Une exposition concrète aux pratiques commerciales internationales",
                      ],
              },
              {
                heading:
                  language == 1
                    ? "Typical Career Outcomes"
                    : "Débouchés professionnels typiques",
                points:
                  language == 1
                    ? [
                        "Business Manager",
                        "Marketing Strategist",
                        "Operations/Project Lead",
                        "International Business Consultant",
                      ]
                    : [
                        "Responsable d’entreprise",
                        "Stratège marketing",
                        "Responsable des opérations / chef de projet",
                        "Consultant en commerce international",
                      ],
              },
            ]}
          />

          {/* CARD 2 (REVERSED) */}
          <Programs_Offered_card
            reverse={true}
            title={
              language == 1
                ? "MIM – Master in Management"
                : "MIM – Master en management"
            }
            image="/assets/images/study_abroad/new-images/MIM.jpg"
            listBlocks={[
              {
                heading:
                  language == 1
                    ? "Designed for fresh graduates or early-career students, the MIM builds strong foundations in"
                    : "Conçu pour les jeunes diplômés ou les étudiants en début de carrière, le MIM permet de construire de solides bases en",
                points:
                  language == 1
                    ? [
                        "Marketing & Communication",
                        "Financial decision-making",
                        "Strategic analysis",
                        "Business innovation",
                        "Team & leadership skills",
                      ]
                    : [
                        "Marketing et communication",
                        "Prise de décision financière",
                        "Analyse stratégique",
                        "Innovation commerciale",
                        "Compétences en travail d’équipe et en leadership",
                      ],
              },
              {
                heading:
                  language == 1
                    ? "Good for students who seek"
                    : "Idéal pour les étudiants qui recherchent",
                points:
                  language == 1
                    ? [
                        "Strong academic grounding",
                        "Entry-level international roles",
                        "Early professional exposure",
                      ]
                    : [
                        "Une solide base académique",
                        "Des postes internationaux de niveau débutant",
                        "Une première expérience professionnelle",
                      ],
              },
            ]}
          />

          {/* CARD 3 */}
          <Programs_Offered_card
            reverse={false}
            title={
              language == 1
                ? "MIR – Master in International Relations"
                : "MIR – Master en relations internationales"
            }
            image="/assets/images/study_abroad/new-images/MIR.jpg"
            listBlocks={[
              {
                heading:
                  language == 1
                    ? "For students interested in diplomacy, policy, and global affairs."
                    : "Pour les étudiants intéressés par la diplomatie, les politiques publiques et les affaires internationales.",
                points:
                  language == 1
                    ? [
                        "Diplomacy & foreign affairs",
                        "Global security & policy",
                        "International institutions",
                        "Cross-border negotiation",
                        "Geopolitical studies",
                      ]
                    : [
                        "Diplomatie et affaires étrangères",
                        "Sécurité mondiale et politiques publiques",
                        "Institutions internationales",
                        "Négociation transfrontalière",
                        "Études géopolitiques",
                      ],
              },
              {
                heading:
                  language == 1
                    ? "Career Pathways"
                    : "Débouchés professionnels",
                points:
                  language == 1
                    ? [
                        "NGOs and international organisations",
                        "Policy & research institutes",
                        "Cultural advisory and development roles",
                      ]
                    : [
                        "ONG et organisations internationales",
                        "Instituts de recherche et de politiques publiques",
                        "Conseil culturel et développement",
                      ],
              },
            ]}
          />
        </div>
      </section>
    </>
  );
}

export default Programs_Offered_Through_AF;
